import styled from 'styled-components';

const TopTitleText = styled.span`
  font-size: 28px;
  font-weight: 400;
  margin-bottom: 24px;
`;

export default TopTitleText;
